import type { ResultType } from '@/pages/YangbokOrg/questionFormTypes';

export const HANBOK_RESULT_TYPES: ResultType[] = [
  {
    key: 'traditionalPremium',
    title: '전통 프리미엄형',
    recommendation: '전통 원단·천연염색 맞춤',
    summary: '한복의 깊이와 기품, 소장 가치를 중요하게 보는 타입이에요.',
    rarityPercent: 18,
    typeExplanation: {
      summary:
        '유행보다 전통적인 색감과 원단, 격식 있는 실루엣에서 만족감을 느끼는 타입이에요.',
      paragraphs: [
        '전통 라인은 색감의 깊이와 원단의 질감이 결과물을 크게 좌우합니다.',
        '맞춤으로 진행하면 소장 가치가 높고, 신부님의 체형과 분위기에 맞는 균형을 세밀하게 잡을 수 있어요.',
        '예산과 제작 기간이 더 필요할 수 있으므로 예식 2~3개월 전 상담을 권장합니다.',
      ],
    },
    styleBars: [
      { label: '전통미', level: '매우 높음', value: 96 },
      { label: '원단 중요도', level: '매우 높음', value: 90 },
      { label: '소장 가치', level: '높음', value: 82 },
      { label: '예산 효율성', level: '보통', value: 45 },
      { label: '프라이빗 경험', level: '높음', value: 76 },
    ],
    mainRecommendation: {
      title: '전통 원단·천연염색 맞춤',
      description:
        '한복의 기품과 깊이를 중요하게 본다면 전통 원단과 천연염색을 다루는 프리미엄 맞춤 라인이 잘 맞습니다.',
      reasons: [
        '차분하고 깊은 색감의 완성도가 좋습니다.',
        '체형과 분위기에 맞춰 실루엣을 세밀하게 조율할 수 있습니다.',
        '본식 이후에도 소장 가치가 있습니다.',
        '격식 있는 혼주 한복과 톤을 맞추기 좋습니다.',
      ],
    },
    upgradeConditions: [
      '예식까지 2개월 이상 여유가 있음',
      '대여보다 소장 가치를 중요하게 생각함',
      '전통 색감과 원단 퀄리티를 직접 보고 고르고 싶음',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '전통 맞춤 한복',
        description:
          '원단과 색감의 깊이를 중요하게 본다면 맞춤 라인을 우선 보세요.',
        highlight: true,
      },
      {
        tag: '예산 조절',
        title: '프리미엄 대여',
        description:
          '맞춤이 부담된다면 전통 색감이 좋은 프리미엄 대여도 함께 비교할 수 있습니다.',
      },
      {
        tag: '상담 포인트',
        title: '원단 선점',
        description:
          '인기 원단은 빨리 빠질 수 있어 일정이 여유 있을 때 방문하는 것이 좋습니다.',
      },
    ],
    matchedShopIds: ['v1', 'v2'],
  },
  {
    key: 'modernDesign',
    title: '모던 디자인형',
    recommendation: '자체 디자인 강한 모던 한복샵',
    summary: '전통보다 세련된 색감과 현대적인 실루엣을 선호하는 타입이에요.',
    rarityPercent: 26,
    typeExplanation: {
      summary:
        '한복을 입었을 때 너무 무겁거나 전통적으로만 보이기보다, 신부님의 분위기와 사진 속 세련됨을 중요하게 보는 타입이에요.',
      paragraphs: [
        '모던 한복샵은 자체 디자인, 배색, 저고리 라인에서 차이가 크게 납니다.',
        '촬영이나 본식 사진에서 얼굴빛이 살아나는 색감을 찾는 것이 핵심이에요.',
        '프리미엄 라인은 개별 룸 상담과 다양한 피팅 경험을 제공하는 경우가 많습니다.',
      ],
    },
    styleBars: [
      { label: '디자인 감도', level: '매우 높음', value: 94 },
      { label: '색감 다양성', level: '높음', value: 84 },
      { label: '사진 만족도', level: '높음', value: 80 },
      { label: '전통미', level: '보통', value: 58 },
      { label: '예산 효율성', level: '보통', value: 52 },
    ],
    mainRecommendation: {
      title: '모던 디자인 한복샵',
      description:
        '현대적이고 세련된 감각을 원한다면 자체 디자인이 강한 모던 한복샵이 잘 맞습니다. 색감과 얼굴빛의 조화를 중심으로 비교하세요.',
      reasons: [
        '자체 디자인과 배색 선택지가 풍부합니다.',
        '촬영과 본식 사진에서 세련된 인상을 만들기 좋습니다.',
        '프라이빗한 상담 경험을 기대할 수 있습니다.',
        '전통미와 현대적인 감각을 균형 있게 가져갈 수 있습니다.',
      ],
    },
    upgradeConditions: [
      '사진 속 색감과 실루엣이 중요함',
      '전통적인 한복보다 세련된 분위기를 원함',
      '직접 여러 벌을 피팅하면서 고르고 싶음',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '모던 한복 피팅',
        description:
          '색감과 실루엣을 직접 입어보며 비교하는 방식이 가장 좋습니다.',
        highlight: true,
      },
      {
        tag: '주의할 점',
        title: '사진 색감 확인',
        description:
          '매장 조명과 예식장 조명에서 색이 달라 보일 수 있어 실제 후기 사진을 확인하세요.',
      },
      {
        tag: '대안',
        title: '전통 포인트 추가',
        description:
          '전체는 모던하게 가되 자수나 노리개로 전통 포인트를 더할 수 있습니다.',
      },
    ],
    matchedShopIds: ['v2', 'v3'],
  },
  {
    key: 'rentalValue',
    title: '대여 실속형',
    recommendation: '가성비 좋은 신부 한복 대여',
    summary: '착용 빈도와 예산을 현실적으로 보고 대여를 선호하는 타입이에요.',
    rarityPercent: 34,
    typeExplanation: {
      summary:
        '한복을 자주 입지 않는다면 합리적인 대여로도 충분히 만족스러운 결과를 만들 수 있다고 보는 타입이에요.',
      paragraphs: [
        '대여는 예산 부담이 낮고 준비 과정이 비교적 단순합니다.',
        '다만 인기 디자인과 사이즈는 먼저 예약될 수 있어 일찍 방문할수록 선택지가 넓어요.',
        '피팅비, 액세서리 포함 여부, 반납 방식까지 견적에 포함해서 비교하는 것이 좋습니다.',
      ],
    },
    styleBars: [
      { label: '예산 효율성', level: '매우 높음', value: 95 },
      { label: '준비 간편함', level: '높음', value: 86 },
      { label: '디자인 선택 폭', level: '높음', value: 74 },
      { label: '소장 가치', level: '낮음', value: 20 },
      { label: '반납 편의성', level: '높음', value: 78 },
    ],
    mainRecommendation: {
      title: '신부 한복 대여',
      description:
        '착용 빈도가 낮고 예산 효율을 중요하게 본다면 대여가 현실적입니다. 디자인 선점과 포함 품목 확인이 핵심입니다.',
      reasons: [
        '맞춤보다 예산 부담이 낮습니다.',
        '착용 빈도가 낮은 신부 한복에 현실적입니다.',
        '피팅 후 빠르게 결정할 수 있습니다.',
        '예식장 근처 반납 등 동선을 줄이기 좋습니다.',
      ],
    },
    upgradeConditions: [
      '한복을 결혼식 이후 자주 입을 계획이 없음',
      '예산을 한복보다 다른 품목에 더 배분하고 싶음',
      '반납 동선과 준비 편의성이 중요함',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '가성비 대여',
        description:
          '예산 효율을 우선한다면 대여 라인에서 색감과 사이즈를 먼저 확인하세요.',
        highlight: true,
      },
      {
        tag: '확인 항목',
        title: '피팅비·액세서리',
        description:
          '뒤꽂이, 손가방, 노리개, 속치마 포함 여부를 견적에 같이 확인하세요.',
      },
      {
        tag: '동선',
        title: '수령·반납 방식',
        description:
          '예식장 근처 반납이 가능한지, 지연료가 있는지 미리 체크하세요.',
      },
    ],
    matchedShopIds: ['v1', 'v3'],
  },
  {
    key: 'familyPackage',
    title: '가족 패키지형',
    recommendation: '혼주 한복·예복 연계 패키지',
    summary: '신부 한복만이 아니라 가족 품목과 묶음 혜택을 함께 보는 타입이에요.',
    rarityPercent: 22,
    typeExplanation: {
      summary:
        '양가 어머님 한복, 신랑 한복, 예복까지 함께 진행해 전체 비용과 동선을 줄이고 싶은 타입이에요.',
      paragraphs: [
        '한복은 가족 품목과 함께 진행할 때 할인 폭이나 서비스 구성이 달라질 수 있습니다.',
        '예복샵과 연계된 한복샵은 상담 동선과 혜택이 좋아질 수 있지만, 개별 견적과 비교해야 실제 이득을 판단할 수 있어요.',
        '양가 어머님 일정 조율과 색상 순서까지 함께 관리하는 것이 중요합니다.',
      ],
    },
    styleBars: [
      { label: '묶음 혜택', level: '매우 높음', value: 94 },
      { label: '가족 일정 조율', level: '높음', value: 84 },
      { label: '예산 관리', level: '높음', value: 78 },
      { label: '단독 디자인 집중도', level: '보통', value: 48 },
      { label: '동선 편의성', level: '높음', value: 80 },
    ],
    mainRecommendation: {
      title: '혼주 한복·예복 연계 패키지',
      description:
        '가족 품목을 함께 준비한다면 묶음 혜택과 일정 조율이 가능한 업체가 잘 맞습니다. 개별 견적과 패키지 견적을 함께 비교하세요.',
      reasons: [
        '양가 어머님 한복까지 한 번에 조율하기 좋습니다.',
        '예복 연계 시 상담 동선과 혜택을 줄일 수 있습니다.',
        '혼주 액세서리 서비스까지 함께 확인할 수 있습니다.',
        '전체 예산을 한 번에 관리하기 좋습니다.',
      ],
    },
    upgradeConditions: [
      '양가 어머님 한복을 함께 진행할 계획',
      '예복과 한복을 묶어 상담받고 싶음',
      '가족 일정과 피팅 동선을 줄이는 것이 중요함',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '가족 패키지 상담',
        description:
          '신부 한복만 보지 말고 혼주 한복, 예복 연계 혜택을 같이 비교하세요.',
        highlight: true,
      },
      {
        tag: '비교 기준',
        title: '개별 견적 vs 묶음 견적',
        description:
          '패키지가 항상 저렴한 것은 아니므로 항목별 견적을 나눠 받아보는 것이 좋습니다.',
      },
      {
        tag: '일정',
        title: '양가 어머님 방문 순서',
        description:
          '색상 선택 폭을 고려해 방문 순서와 피팅 일정을 미리 잡아두세요.',
      },
    ],
    matchedShopIds: ['v2', 'v3'],
  },
];
